module.exports = __webpack_public_path__ + "img/homekv4.c153d764.jpg";